export const validExtensions = {
  applicationAll: "application/*",
  imageAll: "image/*",
  videoAll: "video/*",
  audioAll: "audio/*",
  csv: "text/csv",
  txt: "text/plain"
} as const

export type MediaAssetType = "all" | "image" | "document" | "video" | "audio"

export function isValidFileExtension(type: string, assetType: MediaAssetType) {
  if (assetType === "image")
    return type.startsWith(getNonSpecificExtension(validExtensions.imageAll))

  return Object.values(validExtensions).some((extension) => {
    return type.startsWith(getNonSpecificExtension(extension))
  })
}

/*
 *  Returns valid extensions in their non specific form.
 *  eg: image/* -> image/
 */
function getNonSpecificExtension(inputString: string): string {
  if (inputString.endsWith("/*")) {
    return inputString.slice(0, -1)
  }
  return inputString
}
